var map = {
	"./icon-customer0.png": "5f96",
	"./icon-customer1.png": "e785",
	"./icon-home0.png": "6e0c",
	"./icon-home1.png": "973d",
	"./icon-order0.png": "55f7",
	"./icon-order1.png": "14c5",
	"./icon-visit0.png": "95e4",
	"./icon-visit1.png": "84d1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "27b2";